import { selectNextVulnerableStructure } from '../domain/structures.js';

/**
 * debugDestroyNextVulnerableStructure — Kill next lane structure that is
 * eligible under the requires gate (P3-11). Never bypasses invulnerability.
 */
export function debugDestroyNextVulnerableStructure(structures, team) {
  const peers = structures || [];
  const target = selectNextVulnerableStructure(peers, team);
  if (!target || typeof target.takeDamage !== 'function') {
    return { ok: false, reason: 'none', structure: null };
  }
  if (!Array.isArray(target.structurePeers)) {
    target.structurePeers = peers;
  }
  const result = target.takeDamage(Math.max(target.hp || 0, 1) + 1e6, null, 'true');
  if (result && result.blocked) {
    return { ok: false, reason: 'blocked', structure: target };
  }
  return {
    ok: !!(result && (result.killed || target.isDead)),
    structure: target,
    id: target.id
  };
}
